export default __webpack_public_path__ + "static/industries-Img-c847cf38e3cb293262a4f87a2d2804a8.svg";